/** AP-39 — Anzeige der Status, Arten, Wege und Kennzeichen. */
import type { InboxSource, InboxStatus } from '@symphenia/shared-types'
import { fmtDateTime } from '@/lib/format-date'

export const STATUS_TEXT: Record<InboxStatus, { label: string; klasse: string }> = {
  NEW: { label: 'wird gelesen', klasse: 'bg-muted text-muted-foreground' },
  UNASSIGNED: { label: 'nicht zugeordnet', klasse: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200' },
  SUGGESTED: { label: 'Vorschlag offen', klasse: 'bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-200' },
  ASSIGNED: { label: 'zugeordnet', klasse: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200' },
  DONE: { label: 'erledigt', klasse: 'bg-muted text-muted-foreground' },
  IGNORED: { label: 'ignoriert', klasse: 'bg-muted text-muted-foreground' },
  DUPLICATE: { label: 'Dublette', klasse: 'bg-muted text-muted-foreground' },
  FAILED: { label: 'nicht lesbar', klasse: 'bg-destructive/15 text-destructive' },
}

export { ART_TEXT } from '@/components/eingang/texte'

export const WEG_TEXT: Record<InboxSource, string> = {
  UPLOAD: 'gezogen',
  FOLDER: 'Ordner',
  MAIL: 'E-Mail-Adresse',
}

export const KENNZEICHEN_TEXT: Record<string, string> = {
  UNKNOWN_SENDER: 'unbekannter Absender',
  AUTO_MAIL: 'automatische Mail',
  HELD: 'zurückgehalten',
  DEVIATION: 'Abweichung',
  OFFER_EXPIRES: 'Angebot läuft ab',
  PARTNER_AI: 'Absender von der KI gelesen',
}

export const EREIGNIS_TEXT: Record<string, string> = {
  RECEIVED: 'angekommen',
  RECOGNIZED: 'erkannt',
  ASSIGNED: 'zugeordnet',
  UNASSIGNED: 'Zuordnung gelöst',
  CONFIRMED: 'am Ziel bestätigt',
  IGNORED: 'ignoriert',
  UNIGNORED: 'nicht mehr ignoriert',
  DELETED: 'in den Papierkorb',
  RESTORED: 'wiederhergestellt',
  AI_CLASSIFIED: 'mit KI erkannt',
  AI_READ: 'Werte mit KI gelesen',
  AI_FAILED: 'Lesen mit KI fehlgeschlagen',
}

/** Eingang mit Uhrzeit in der Zeit des Betrachters — ein echter Zeitpunkt, keine Wandzeit. */
export function eingangText(iso: string): string {
  return iso ? fmtDateTime(iso) : ''
}

export function groesseText(bytes: number | null): string {
  if (!bytes) return ''
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`
  return `${(bytes / 1024 / 1024).toLocaleString('de-DE', { maximumFractionDigits: 1 })} MB`
}
